export const ADD_DUPE_VEHICLE = 'ADD_DUPE_VEHICLE';
export const REMOVE_DUPE_VEHICLE = 'REMOVE_DUPE_VEHICLE';
export const CLEAR_DUPE_VEHICLE = 'CLEAR_DUPE_VEHICLE';
